"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _collapse = _interopRequireDefault(require("../../core/collapse"));
var _button = _interopRequireDefault(require("../../core/button"));
var _modal = _interopRequireDefault(require("../../core/modal"));
var _submit = _interopRequireDefault(require("../../core/submit"));
var _row = _interopRequireDefault(require("../../core/row"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _input = _interopRequireDefault(require("../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _selectCode = _interopRequireDefault(require("../../core/select-code"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  newAgeCategory: {
    id: null,
    description: null,
    minAge: null,
    maxAge: null
  },
  isOpened: false,
  isSubmitting: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_label.default, null, "ID");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Description");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Minimum Age");
var _ref4 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Maximum Age");
class AddAgeCategory extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_toggleOpened", () => {
      this.setState({
        isOpened: !this.state.isOpened
      });
    });
    _defineProperty(this, "_onCancelNewAgeCategory", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_setValue", (field, value) => {
      this.setState({
        newAgeCategory: {
          ...this.state.newAgeCategory,
          [field]: value
        }
      });
    });
    _defineProperty(this, "_onSubmit", e => {
      e.preventDefault();
      this.setState({
        isSubmitting: true
      });
      this.props.addAgeCategory(this.state.newAgeCategory).then(result => {
        if (result && result.error) {
          this.setState({
            errorMessage: result.error,
            isSubmitting: false
          });
        } else {
          this.setState(initialState);
        }
      });
    });
    _defineProperty(this, "_onErrorDismissed", () => {
      this.setState({
        errorMessage: null
      });
    });
  }
  render() {
    const dismissErrorButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onErrorDismissed
    }, "OK");
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleOpened
    }, this.state.isOpened ? 'Hide New Age Category' : 'Add Age Category'), /*#__PURE__*/_react.default.createElement(_collapse.default, {
      isOpened: this.state.isOpened,
      transitionMS: 500
    }, ' ', /*#__PURE__*/_react.default.createElement("div", null, !this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: dismissErrorButton,
      onClose: this.props.onErrorDismissed
    }, this.state.errorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this._onSubmit
    }, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4,
        md: 3
      }, {
        sm: 8,
        md: 9
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "id",
      value: this.state.newAgeCategory.id,
      onChange: this._setValue.bind(this, 'id'),
      maxLength: 10,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "description",
      value: this.state.newAgeCategory.description,
      onChange: this._setValue.bind(this, 'description'),
      maxLength: 40,
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "minAge",
      type: "Integer",
      value: this.state.newAgeCategory.minAge,
      onChange: this._setValue.bind(this, 'minAge'),
      maxLength: 4
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      name: "minAge",
      type: "Integer",
      value: this.state.newAgeCategory.maxAge,
      onChange: this._setValue.bind(this, 'maxAge'),
      maxLength: 4
    })))), /*#__PURE__*/_react.default.createElement(_submit.default, {
      loading: this.state.isSubmitting
    }, "Add Age Category"), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCancelNewAgeCategory
    }, "Cancel")))))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _reactBicycle.connect)(AddAgeCategory, undefined, (client, props) => ({
  addAgeCategory(newAgeCategory) {
    return client.update('AgeCategory.create', newAgeCategory);
  }
}));